import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/session';
import paymentReducer from './slices/payment';
import { persistStore } from 'redux-persist';
import { languageChangeSubscription } from './events/LanguageChangeSubscription';

export const store = configureStore({
  reducer: combineReducers({
    auth: authReducer,
    payment: paymentReducer,
  })
});

store.subscribe(() => { languageChangeSubscription(store) });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
export default store;